/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Nug = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Nug"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4BA279"
        d="M19.5 2A2.5 2.5 0 0 1 22 4.5c0 .89-.466 1.668-1.166 2.111a4.167 4.167 0 0 1-1.378 6.727 5 5 0 0 1-6.126 7.41 2.496 2.496 0 0 1-4.534-.459 5.83 5.83 0 0 1-5.086-5.086 2.499 2.499 0 0 1-.459-4.534 5 5 0 0 1 7.41-6.126 4.168 4.168 0 0 1 6.727-1.378A2.5 2.5 0 0 1 19.5 2"
        className="Main"
      />
      <path
        fill="#4BA279"
        fillRule="evenodd"
        d="M7 17.833c0 .46-.373.834-.833.834a2.5 2.5 0 0 0-2.5 2.5.833.833 0 0 1-1.667 0A4.167 4.167 0 0 1 6.167 17c.46 0 .833.373.833.833"
        className="Details"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M6.167 17a.834.834 0 0 1 0 1.667 2.5 2.5 0 0 0-2.5 2.5.834.834 0 0 1-1.667 0A4.167 4.167 0 0 1 6.167 17M12 17a.834.834 0 0 1 .085 1.663l-.17.008a.833.833 0 0 0-.748.829.834.834 0 0 1-1.667 0A2.5 2.5 0 0 1 12 17m2.5.834a.833.833 0 1 1 0 1.665.833.833 0 0 1 0-1.665m3.333-4.167a.834.834 0 1 1 0 1.667.833.833 0 0 0-.83.748l-.007.17a.834.834 0 0 1-1.663-.085 2.5 2.5 0 0 1 2.5-2.5m-10 .833a.834.834 0 1 1 0 1.669.834.834 0 0 1 0-1.67m5-2.5a.834.834 0 0 1 0 1.667.834.834 0 0 0-.83.748l-.007.17a.834.834 0 0 1-1.663-.085 2.5 2.5 0 0 1 2.5-2.5m-7.5 0a.834.834 0 1 1 0 1.669.834.834 0 0 1 0-1.67m3.334-1.666a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666m9.166-1.667a.834.834 0 1 1 0 1.667.833.833 0 0 0-.83.748l-.007.17a.834.834 0 0 1-1.663-.085 2.5 2.5 0 0 1 2.5-2.5m-5 0a.834.834 0 1 1 0 1.667.834.834 0 0 1 0-1.667m-5-2.5a.834.834 0 1 1 0 1.667.833.833 0 0 0-.83.748l-.007.17a.834.834 0 0 1-1.663-.085 2.5 2.5 0 0 1 2.5-2.5m3.334-.833a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666m5-1.667a.833.833 0 0 1 0 1.667.834.834 0 0 0-.834.833.833.833 0 1 1-1.666 0 2.5 2.5 0 0 1 2.5-2.5m2.5 1.667a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666"
        className="Details"
      />
    </g>
  </svg>
);

export const NugIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'nug-icon'}
      icon={Nug}
      {...props}
      size={size}
    />
  );
};
